import "./index.scss";
import HomeMap from "../../assets/img/Homescreen-full-map.png";
import VerticalLine from "../../components/icons/VerticalLine";
import Logo from "../../components/icons/Logo";
import Touch from "../../assets/img/Blue-Touch-Icon.gif";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../context/DataProvider";
import InitialEngagement from "../../components/icons/NavIcons/InitialEngagemement";
import Hotel from "../../components/icons/NavIcons/Hotel";
import ConferenceCenterAndBallroom from "../../components/icons/NavIcons/ConferenceCenterAndBallroom";
import OnSiteDining from "../../components/icons/NavIcons/OnSiteDining";
import GolfCourse from "../../components/icons/NavIcons/GolfCourse";
import Spa from "../../components/icons/NavIcons/Spa";
import ContinuousConnections from "../../components/icons/NavIcons/ContinuousConnections";
import Theatre from "../../components/icons/NavIcons/Theatre";
import GasStation from "../../components/icons/NavIcons/GasStation";
import Casino from "../../components/icons/NavIcons/Casino";
import PickleballCourt from "../../components/icons/NavIcons/PickleballCourt";
import SpecialEvents from "../../components/icons/NavIcons/SpecialEvents";
import ResidentialBuilding from "../../components/icons/NavIcons/ResidentialBuilding";
const LandingPage = () => { 
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash landingPage">
            <div className="home-map">
                <div className="pickleball">
                    <PickleballCourt onClick={()=>{
                        _logEvent('click', "Main Map", "Pickleball Court");
                        addFlow("Pickleball Court");
                        navigate("/pickleball");
                    }} />
                </div>
                <div className="special-events">
                    <SpecialEvents onClick={()=>{
                        _logEvent('click', "Main Map", "Special Events Venue");
                        addFlow("Special Events Venue");
                        navigate("/special-events");
                    }} />
                </div>
                <div className="residential">
                    <ResidentialBuilding onClick={()=>{
                        _logEvent('click', "Main Map", "Residential Building");
                        addFlow("Residential Building");
                        navigate("/residential");
                    }} />
                </div>
                <div className="dining">
                    <OnSiteDining onClick={()=>{
                        _logEvent('click', "Main Map", "Dining");
                        addFlow("Dining");
                        navigate("/dining");
                    }} />
                </div>
                <div className="golf">
                    <GolfCourse onClick={()=>{
                        _logEvent('click', "Main Map", "Golf");
                        addFlow("Golf");
                        navigate("/golf");
                    }} />
                </div>
                <div className="spa">
                    <Spa onClick={()=>{
                        _logEvent('click', "Main Map", "Spa");
                        addFlow("Spa");
                        navigate("/spa");
                    }} />
                </div>
            </div>
            <div className="logo" onClick={()=>{
                _logEvent('click', "Main Map", "Agilysys");
                addFlow("Agilysys");
                navigate("/aboutus");
            }}><Logo /></div>
            <div className="top-left">
                <div className="topic-header">
                    Maximize Return on Experience{'\n'}
                    <span className="sub-topic-header">
                        For{" "}<strong>Active Adult Communities</strong>
                    </span>
                </div>
                <div className="column">
                    <div className="row"><span>Delight</span> residents</div>
                    <div className="row"><span>Retain</span> staff</div>
                    <div className="row"><span>Grow</span> margins</div>
                    <div className="line"><VerticalLine /></div>
                </div>
            </div>
            
            <div className="bottom-left">
                <img className="touch-prompt" src={Touch} alt=""/>
                <div className="block">
                    Explore our interactive{'\n'}
                    Active Adult Community map to discover{'\n'}
                    where <span>personal</span> meets <span>profitable</span>{'\n'}
                    <strong>Touch an area to begin!</strong>
                </div>
                
            </div>
    
        </div>
    )
}
export default LandingPage;